import { FormSectionHandler } from '../entity.handler';
import { AssetCategoryResponse, IdName, AssetCategoryUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField, IdNameComboValueHandlers } from '../utils';
import { AssetGroupingService } from 'app/services';
import { ICONS } from '../icons';

interface EditorValues {
    name?: string;
    parent?: IdName;
}


export class AssetCategoryDetailsSectionHandler implements FormSectionHandler<AssetCategoryResponse, EditorValues> {

    type = 'form';
    icon = ICONS.assetcategory;
    bulk = true;
    
    title = this.translate('TITLE'); 
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string,
        private grouping: AssetGroupingService,
        private creating: boolean
    ) {
    }

    private properties = ['name', 'parent'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.ASSETCATEGORY.DETAILS.${key}`, values);
    }

    applyUpdate(entity: AssetCategoryResponse, payload: AssetCategoryUpdateRequest): Promise<AssetCategoryResponse> {
        this.grouping.clear(); // clear our grouping cache after an update
        return this.admin.applyUpdate(api => api.entities.updateAssetCategory(entity.id, payload));
    }

    mapEntityToEditor(entity: AssetCategoryResponse): Promise<EditorValues> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: AssetCategoryUpdateRequest, values: EditorValues): Promise<AssetCategoryUpdateRequest> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, values, entity));
    }

    getFields(entity: AssetCategoryResponse): Promise<FormBuilderField[]> {

        const index = (entity && entity.index) || 0;
        return this.grouping.getAssetCategories(this.ownerId).then(categories => {

            // if we're updating a category, restrict parents to the current root. if it's new, inject a dummy root node
            const groups = entity && entity.id
                ? categories.filter(x => x.index === index)
                : [AssetGroupingService.createRootNode(this.ownerId), ...categories];

            return [
                this.creating || entity.parent ? ComboField('parent', this.translate('FIELDS.PARENT'), true, EntityUtils.treeToComboValues(groups), IdNameComboValueHandlers) : null,
                TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
            ].filter(x => x);
        }).then(fields => EntityUtils.prepareBulk(!entity, [], fields));
    }

}
